import axios from 'axios';
import { API } from '../utils/constants';

// ============ AUTH ============
export const login = async (username, password, location) => {
  const res = await axios.post(`${API}/auth/login`, {
    username: username.trim(), 
    password, 
    location 
  });
  return res.data;
};

// ============ WAITERS ============
export const getWaiters = async (location) => {
  const res = await axios.get(`${API}/waiters?location=${location}`);
  return res.data;
};

export const createWaiter = async (firstName, lastName, branch, status, location) => {
  const res = await axios.post(`${API}/waiters`, {
    firstName: firstName.trim(),
    lastName: lastName.trim(),
    branch: branch.trim(),
    status,
    location
  });
  return res.data;
};

export const updateWaiterStatus = async (waiterId, status) => {
  const res = await axios.put(`${API}/waiters/${waiterId}/status`, { status });
  return res.data;
};

// ============ ENTRIES (TIPS) ============
export const getEntries = async (location) => {
  const res = await axios.get(`${API}/entries?location=${location}`);
  return res.data;
};

export const createEntry = async (entryData) => {
  const res = await axios.post(`${API}/entries`, entryData);
  return res.data;
};

export const deleteEntry = async (entryId) => {
  const res = await axios.delete(`${API}/entries/${entryId}`);
  return res.data;
};

// ============ CLOSED DAYS ============
export const getClosedDays = async (location) => {
  const res = await axios.get(`${API}/closed-days?location=${location}`);
  return res.data;
};

export const closeDay = async (date, closedBy, location) => {
  const res = await axios.post(`${API}/closed-days`, { date, closedBy, location });
  return res.data;
};

export const reopenDay = async (date, location) => {
  const res = await axios.delete(`${API}/closed-days/${date}?location=${location}`);
  return res.data;
};

// ============ BILLARD ============
export const getBillardEntries = async (location) => {
  const res = await axios.get(`${API}/billard?location=${location}`);
  return res.data;
};

export const createBillardEntry = async (entryData) => {
  const res = await axios.post(`${API}/billard`, entryData);
  return res.data;
};

export const deleteBillardEntry = async (entryId, location) => {
  const res = await axios.delete(`${API}/billard/${entryId}?location=${location}`);
  return res.data;
};

// ============ USERS ============
export const getUsers = async (location) => {
  const res = await axios.get(`${API}/users?location=${location}`);
  return res.data;
};

export const createUser = async (username, password, role, location) => {
  const res = await axios.post(`${API}/users`, {
    username: username.trim(),
    password,
    role,
    location
  });
  return res.data;
};

export const deleteUser = async (userId) => {
  const res = await axios.delete(`${API}/users/${userId}`);
  return res.data;
};

export const changeUserPassword = async (userId, newPassword) => {
  const res = await axios.put(`${API}/users/${userId}/password`, { newPassword });
  return res.data;
};

// ============ BACKUP & RESTORE ============
export const downloadBackup = async (location) => {
  const res = await axios.get(`${API}/backup?location=${location}`);
  return res.data;
};

export const restoreBackup = async (data, location) => {
  const res = await axios.post(`${API}/restore?location=${location}`, data);
  return res.data;
};

export const resetData = async (location) => {
  const res = await axios.delete(`${API}/reset?location=${location}`);
  return res.data;
};

// ============ CLOTHING ============
export const getClothingItems = async (location) => {
  const res = await axios.get(`${API}/clothing?location=${location}`);
  return res.data;
};

export const issueClothing = async (itemData) => {
  const res = await axios.post(`${API}/clothing`, itemData);
  return res.data;
};

export const returnClothing = async (itemId, returnedDate) => {
  const res = await axios.put(`${API}/clothing/${itemId}/return`, { returnedDate });
  return res.data;
};

export const deleteClothingItem = async (itemId) => {
  const res = await axios.delete(`${API}/clothing/${itemId}`);
  return res.data;
};

// ============ JOB POSITIONS ============
export const getJobPositions = async (location) => {
  const res = await axios.get(`${API}/job-positions?location=${location}`);
  return res.data;
};

export const createJobPosition = async (name, location) => {
  const res = await axios.post(`${API}/job-positions`, { name, location });
  return res.data;
};

export const deleteJobPosition = async (positionId) => {
  const res = await axios.delete(`${API}/job-positions/${positionId}`);
  return res.data;
};

// ============ CLOTHING TYPES ============
export const getClothingTypes = async (location) => {
  const res = await axios.get(`${API}/clothing-types?location=${location}`);
  return res.data;
};

export const createClothingType = async (name, location) => {
  const res = await axios.post(`${API}/clothing-types`, { name, location });
  return res.data;
};

export const deleteClothingType = async (typeId) => {
  const res = await axios.delete(`${API}/clothing-types/${typeId}`);
  return res.data;
};

// ============ DATA CLEANUP ============
export const cleanupOldData = async (location, daysToKeep) => {
  const res = await axios.post(`${API}/cleanup-old-data?location=${location}&days_to_keep=${daysToKeep}`);
  return res.data;
};

// ============ GLASS MANAGEMENT ============
export const getGlassTypes = async (location) => {
  const res = await axios.get(`${API}/glass/types?location=${location}`);
  return res.data;
};

export const createGlassType = async (name, location) => {
  const res = await axios.post(`${API}/glass/types`, { name, location });
  return res.data;
};

export const updateGlassType = async (typeId, name) => {
  const res = await axios.put(`${API}/glass/types/${typeId}`, { name });
  return res.data;
};

export const deleteGlassType = async (typeId) => {
  const res = await axios.delete(`${API}/glass/types/${typeId}`);
  return res.data;
};

export const getGlassInventory = async (location) => {
  const res = await axios.get(`${API}/glass/inventory?location=${location}`);
  return res.data;
};

export const saveGlassInventory = async (inventoryData) => {
  const res = await axios.post(`${API}/glass/inventory`, inventoryData);
  return res.data;
};

export const updateGlassInventory = async (inventoryId, inventoryData) => {
  const res = await axios.put(`${API}/glass/inventory/${inventoryId}`, inventoryData);
  return res.data;
};

export const deleteGlassInventory = async (inventoryId) => {
  const res = await axios.delete(`${API}/glass/inventory/${inventoryId}`);
  return res.data;
};

// ============ KITCHEN LOSSES ============
export const getProducts = async (location) => {
  const res = await axios.get(`${API}/kitchen-losses/products?location=${location}`);
  return res.data;
};

export const createProduct = async (name, location) => {
  const res = await axios.post(`${API}/kitchen-losses/products`, { name, location });
  return res.data;
};

export const deleteProduct = async (productId) => {
  const res = await axios.delete(`${API}/kitchen-losses/products/${productId}`);
  return res.data;
};

export const getKitchenLosses = async (location) => {
  const res = await axios.get(`${API}/kitchen-losses?location=${location}`);
  return res.data;
};

export const createKitchenLoss = async (lossData) => {
  const res = await axios.post(`${API}/kitchen-losses`, lossData);
  return res.data;
};

export const updateKitchenLoss = async (lossId, lossData) => {
  const res = await axios.put(`${API}/kitchen-losses/${lossId}`, lossData);
  return res.data;
};

export const deleteKitchenLoss = async (lossId) => {
  const res = await axios.delete(`${API}/kitchen-losses/${lossId}`);
  return res.data;
};

// ============ BEER CLEANING ============
export const getBeerCleanings = async (location) => {
  const res = await axios.get(`${API}/beer-cleaning?location=${location}`);
  return res.data;
};

export const getLatestBeerCleaning = async (location) => {
  const res = await axios.get(`${API}/beer-cleaning/latest?location=${location}`);
  return res.data;
};

export const createBeerCleaning = async (cleaningData) => {
  const res = await axios.post(`${API}/beer-cleaning/`, cleaningData);
  return res.data;
};

export const deleteBeerCleaning = async (cleaningId) => {
  const res = await axios.delete(`${API}/beer-cleaning/${cleaningId}`);
  return res.data;
};

// ============ SETTINGS & BACKUP ADVANCED ============
export const getBackupList = async (location) => {
  const res = await axios.get(`${API}/settings/backups/list?location=${location}`);
  return res.data;
};

export const getBackupById = async (backupId) => {
  const res = await axios.get(`${API}/settings/backups/${backupId}`);
  return res.data;
};

export const restoreFromArchive = async (backupId) => {
  const res = await axios.post(`${API}/settings/backups/${backupId}/restore`);
  return res.data;
};

export const deleteBackup = async (backupId) => {
  const res = await axios.delete(`${API}/settings/backups/${backupId}`);
  return res.data;
};

export const getAuditLog = async (location, limit = 100) => {
  const res = await axios.get(`${API}/settings/audit-log?location=${location}&limit=${limit}`);
  return res.data;
};

export const getLastBackupInfo = async (location) => {
  const res = await axios.get(`${API}/settings/last-backup?location=${location}`);
  return res.data;
};

export const confirmBackup = async (location, confirmedBy) => {
  const res = await axios.post(`${API}/settings/confirm-backup`, { location, confirmedBy });
  return res.data;
};

// ============ USER PERMISSIONS ============
export const updateUserPermissions = async (userId, permissions) => {
  const res = await axios.put(`${API}/users/${userId}/permissions`, { permissions });
  return res.data;
};

export const updateJobPosition = async (positionId, name) => {
  const res = await axios.put(`${API}/job-positions/${positionId}`, { name });
  return res.data;
};

export const updateClothingType = async (typeId, name) => {
  const res = await axios.put(`${API}/clothing-types/${typeId}`, { name });
  return res.data;
};




